<template>
  <div class="degreeApplication">
    <div class="degreeApplication-box">
        <div class="title">成人本科学士学位申报流程</div>
        <div class="tabs">
            <el-tabs v-model="activeName" @tab-click="tabsClick">
                <el-tab-pane label="第一步、自我审查" name="one">
                    <SelfExamination />
                </el-tab-pane>
                <el-tab-pane label="第二步、材料准备" name="two">
                    <MaterialScience />
                </el-tab-pane>
                <el-tab-pane label="第三步、网上申报" name="three">
                    <OnlineDeclaration @submitSuccess="submitSuccess" />
                </el-tab-pane>
                <el-tab-pane label="第四步、材料寄送" name="four">
                    <MaterialDelivery />
                </el-tab-pane>
            </el-tabs>
            <div class="applicationRecord">
                <el-button type="primary" @click="go">查看申请记录</el-button>
            </div>
        </div> 
    </div>
  </div>
</template>

<script>
import SelfExamination from './components/selfExamination';  //自我审查
import MaterialScience from './components/materialScience';  //材料准备
import OnlineDeclaration from './components/onlineDeclaration';  //网上申报
import MaterialDelivery from './components/materialDelivery';  //材料寄送

export default {
    name: "degreeApplication",
    components: {
        SelfExamination,
        MaterialScience,
        OnlineDeclaration,
        MaterialDelivery,
    },
    data() {
        return {
            activeName: 'one',

        };
    },
    created() {
        
    },
    methods: {
        // 点击 查看申请记录 按钮
        go(){
            this.$router.push({name: 'academicDegreeRecord'});
        },
        submitSuccess(){
            this.activeName = 'four';
        },
        //点击tabs
        tabsClick(v){
            this.activeName = v.name;
        },
    },
};
</script>

<style lang="scss">
.degreeApplication{
    .el-tabs__header{
        background-color: #fff;
        position: sticky;
        top: 74px;
        z-index: 9;
        margin-top: -20px;
    }
}
</style>
<style lang="scss" scoped>
.degreeApplication{
    height: 100vh;
    overflow-y: auto;
    .degreeApplication-box{
        background-color: #fff;
        // padding: 20px;
    }
    .title{
        padding-top: 20px;
        background-color: #fff;
        font-size: 36px;
        text-align: center;
        position: sticky;
        top: 0;
        z-index: 9;
    }
    .tabs{
        padding: 20px;
        position: relative;
        .applicationRecord{
            position: absolute;
            top: 0;
            right: 10px;
            z-index: 99;
        }
    }
    
}
</style>
